import {DataObjectId} from './data-object'

export const appName = 'YouGileApp'

export const rootNodeId = '00000000-8403-48e4-8004-c0956e0f6a20' as DataObjectId

export const disabledUserId = 'not available' as DataObjectId

export const noBoardContainerId =
  '000071aa-fe2d-436a-bb31-489d26f4e4b8' as DataObjectId

// used for newly created system tags (old uses random id)
export const systemTagsIds = {
  access: '00044102-81c1-4d66-b125-a1ba3ff3da04' as DataObjectId,
  notify: '000b50cc-236f-40b4-bb78-616946ba7f1c' as DataObjectId,
  'task-completed': '000416c0-651b-4b14-b826-c92feea5af0e' as DataObjectId,
  'seen-by': '000bf81c-8b00-4860-b1f0-754063e1cdf3' as DataObjectId,
  'created-by': '000a7340-c631-4aaf-a76b-34bc7bafc973' as DataObjectId
}

export const systemStickers = {
  User: '00034c16-00b9-4ac7-ab24-fb60dc92ec5e' as DataObjectId,
  Deadline: '00050d5a-64a9-49a6-8bec-f883d8909173' as DataObjectId,
  Timer: '00077360-e21d-4d52-b0e5-52154a9f0e89' as DataObjectId,
  /**
   * @deprecated don't use in frontend
   */
  Stopwatch: '0009deed-8b56-4529-8a4e-04bbe63f550f' as DataObjectId,
  Timetracking: '000668ea-6126-4ae0-b195-0924b035e6b6' as DataObjectId,
  Repeat: '00052e3a-ce40-4c0e-a2a0-140e3b01f217' as DataObjectId
}

export const crmDealAmountStickerId =
  '00000000-783c-46c9-b1b9-c828973c7dd5' as DataObjectId

export const systemStickersIdsMap = Object.keys(systemStickers).reduce(
  (acc, stickerName) => {
    acc[systemStickers[stickerName as keyof typeof systemStickers]] =
      stickerName
    return acc
  },
  {} as {[id: DataObjectId]: string}
)

export const stickersContainerId =
  '000161c9-51c1-474b-8100-8a36d0877ddf' as DataObjectId
export const scriptsContainerId =
  '00049740-86f1-4edf-8f07-189a1d93753b' as DataObjectId
export const repeatTemplatesContainerId =
  '000eef2b-a4f9-4311-a5a2-bda62c700351' as DataObjectId
export const movementTemplatesContainerId =
  'bd89c444-5eba-4ada-81fe-9912974b8411' as DataObjectId
export const taskTemplatesContainerId =
  '4befbb6a-9e0c-4bb0-8a0f-b52e911b7676' as DataObjectId
export const extensionsContainerId =
  '00000000-5c4e-4f2b-94d7-8a9c3e52f1b6' as DataObjectId

export const irrelevantCompanyId = 'any-company-id' as DataObjectId

export const irrelevantUserId = 'any-user-id' as DataObjectId

export const newsCompanyId =
  'ae0bd624-cd07-4c48-b4f2-ce4bfda36df1' as DataObjectId

export const extensionPublicHubTitlePrefix = 'extension-public-hub'

export const keepUnseenInfoInterval = 7 * 24 * 3600 * 1000
export const maxDeleteUnseen = 1000

export class Const {
  public static readonly chatWidthKey: string = 'ui:chat:chatWidth'
}

export const emailChangeTokenLifetime = 24 * 60 * 60 * 1000

export const googleCalendarRedirectPage = 'google-calendar-auth-page'

export const availablePhoneCountries = ['RU', 'BY']
